import { render, staticRenderFns } from "./TextItem.vue?vue&type=template&id=536eeaf4"
import script from "./TextItem.vue?vue&type=script&lang=js"
export * from "./TextItem.vue?vue&type=script&lang=js"
import style0 from "./TextItem.vue?vue&type=style&index=0&id=536eeaf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports